<template>
  <div class="navbar-container d-flex content align-items-center">
    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>
  
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">
      <sites-dropdown />
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <locale />
      <!-- <notification-dropdown /> -->
      <user-dropdown />
    </b-navbar-nav>
  </div>
</template>

<script>
  import {
    BLink, BNavbarNav,
  } from 'bootstrap-vue'
  import Locale from './components/Locale.vue'
  import NotificationDropdown from './components/NotificationDropdown.vue'
  import UserDropdown from './components/UserDropdown.vue'
  import SitesDropdown from './components/SitesDropdown.vue'

export default {
  components: {
    BLink,
    BNavbarNav,
    Locale,
    NotificationDropdown,
    UserDropdown,
    SitesDropdown
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
}
</script>
